<!--
 * @Author: ShiWeiShan
 * @Date: 2020-12-24 13:01:29
 * @LastEditTime: 2020-12-24 13:18:45
 * @LastEditors: ShiWeiShan
 * @Description: 通知详情
 * @FilePath: \fs-js-pcweb-user\src\components\messageForm\noticeInfo.vue
-->
<template>
  <div class="notice-info">
    <!-- 通知公告：当前选中内容 -->
    <el-form :model="recordData" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="通知类型：">
            <el-input v-model="recordData.notice_type_text" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="重要性：">
            <el-input v-model="recordData.importance_text" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="通知概述：">
            <el-input type="textarea" v-model="recordData.notice_desc" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <wangEditor v-model="recordData.notice_html"></wangEditor>
    </el-form>
  </div>
</template>

<script>
import wangEditor from "@/components/wangeditors/index"
export default {
  components: {
    wangEditor
  },
  props: {
    recordData: {
      type: Object
    }
  },
  data() {
    return {
    }
  },
  methods: {
    // 功能：重置
  }
}
</script>

<style lang="scss" scoped>
.notice-info{
  padding: 10px;
}
</style>